module.exports = __webpack_public_path__ + "img/ch53.1a645306.png";